import { render } from "./EmployeesDashboardTasks.vue?vue&type=template&id=716bbae0"
import script from "./EmployeesDashboardTasks.vue?vue&type=script&lang=js"
export * from "./EmployeesDashboardTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__